<template>
  <div class="vacancy-hrm">
    <vacancy-title />

    <div class="vacancy-hrm__body">
      <div class="vacancy-hrm__actions">
        <vbutton :label="$tr('hrm.refresh-list')" size="small" @click="forceSync" />
      </div>

      <v-table
        :headers="tableHeaders"
        :loading="isHrmLoading"
        :items="hrmProjects"
        :is-show-actions="false"
        is-show-filter
      >
        <template #header="{ header }">
          <vcv-vacancy-hrm-tablehead
            :header="header"
            :sorting="sorting"
            :show-filter="showFilter"
            :filter-title-selected="projectsHrmFilters.title"
            :filter-region-selected="projectsHrmFilters.region"
            :filter-author="hrmManagers"
            :filter-author-selected="projectsHrmFilters.author"
            @set-show-filter="showFilter = $event"
            @set-temp-title="SET_FILTER_PROPERTY({ property: 'title', value: $event })"
            @set-temp-region="SET_FILTER_PROPERTY({ property: 'region', value: $event })"
            @set-temp-author="SET_FILTER_PROPERTY({ property: 'author', value: $event })"
            @apply-filter="applyFilter"
          />
        </template>

        <template #cell="{ header, cell }">
          <template v-if="header.id === 'manager_id'">
            {{
              cell._embedded.manager !== undefined
                ? `${cell._embedded.manager.full_name} (${cell._embedded.manager.email})`
                : ''
            }}
          </template>

          <template v-else>{{ cell[header.id] }}</template>
        </template>

        <template #row-action="{ cell }">
          <div class="vacancy-hrm__table-actions">
            <trigger
              class="vacancy-hrm__switcher"
              :value="isShowConnectedSign(cell) ? true : cell.isActive"
              :disabled="isSwitchDisabled(cell)"
              @input="toggleHrmProject({ cell, vacancyId: vacancy.id })"
            />

            <span v-if="isShowConnectedSign(cell)" class="vacancy-hrm__actions-info">
              <img
                v-tooltip="{
                  content: $tr('hrm.project-already-connected'),
                  placement: 'left',
                  classes: 'tight'
                }"
                class="vmodule_icon-lock"
                src="/static/images/elements/vmodule-icon-info.svg"
              />
            </span>
          </div>
        </template>
      </v-table>

      <vcv-pagination
        :params="hrmProjectsPagination"
        :is-loading="isHrmLoading"
        is-left
        show-counts
        @on-page-change="onPageChange"
        @on-limit-change="onLimitChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import VTable from '@/components/table';
import VcvVacancyHrmTablehead from '@/routes_new/inner/vacancy/integrations/VcvVacancyHrmTablehead.vue';
import VacancyTitle from '@/routes_new/inner/vacancy/components/vtitle';
import VcvPagination from '@/components_new/complex/VcvPagination.vue';
import Trigger from '@/components/shared/Trigger.vue';

export default {
  name: 'VacancyHrm',

  components: {
    VTable,
    VacancyTitle,
    Trigger,
    VcvPagination,
    VcvVacancyHrmTablehead
  },

  data() {
    return {
      tableHeaders: [
        { id: 'id', is_visible: false, is_base: true, name: '#', width: '' },
        { id: 'title', is_visible: true, is_base: true, name: 'Название', width: '' },
        { id: 'region', is_visible: true, is_base: true, name: 'Регион', width: '' },
        { id: 'manager_id', is_visible: true, is_base: true, name: 'Менеджер', width: '' },
        { id: 'row-action', is_visible: true, is_base: true, name: this.$tr('integrations.connect'), width: '' }
      ],

      showFilter: 'none',
      sorting: { name: 'created_at', order: 'desc' }
    };
  },

  computed: {
    ...mapState('integrationsHrm', [
      'hrmProjects',
      'hrmManagers',
      'isHrmLoading',
      'isConnectionLoading',
      'hrmProjectsPagination',
      'projectsHrmFilters'
    ]),

    ...mapGetters('integrationsHrm', ['vacanciesAlreadyConnected']),

    ...mapState('vacancy_new', { vacancy: 'item' })
  },

  async created() {
    await this.fetchHrmProjects();
    await this.fetchHrmManagers(); // запрос полного списка менеджеров для фильтра по менеджерам
  },

  methods: {
    ...mapMutations('integrationsHrm', ['SET_HRM_PROJECTS_PAGINATION', 'SET_FILTER_PROPERTY']),

    ...mapActions('integrationsHrm', ['fetchHrmProjects', 'toggleHrmProject', 'forceSync', 'fetchHrmManagers']),

    isSwitchDisabled(cell) {
      if (this.isConnectionLoading) return true;

      if (cell._embedded.vacancy !== undefined && cell._embedded.vacancy.vcv_vacancy_id !== undefined) {
        return (
          this.vacanciesAlreadyConnected.includes(cell._embedded.vacancy.vcv_vacancy_id) &&
          cell._embedded.vacancy.vcv_vacancy_id != this.vacancy.id
        );
      }

      return false;
    },

    isShowConnectedSign(cell) {
      if (cell._embedded.vacancy !== undefined && cell._embedded.vacancy.vcv_vacancy_id) {
        if (
          this.vacanciesAlreadyConnected.includes(cell._embedded.vacancy.vcv_vacancy_id) &&
          cell._embedded.vacancy.vcv_vacancy_id != this.vacancy.id
        ) {
          return true;
        }
      }

      return false;
    },

    async onPageChange(value) {
      this.SET_HRM_PROJECTS_PAGINATION({ property: '_page', value });

      await this.fetchHrmProjects();
    },

    async onLimitChange(value) {
      this.SET_HRM_PROJECTS_PAGINATION({ property: '_limit', value });
      this.SET_HRM_PROJECTS_PAGINATION({ property: '_page', value: 1 });

      await this.fetchHrmProjects();
    },

    async applyFilter() {
      this.SET_HRM_PROJECTS_PAGINATION({ property: '_page', value: 1 });

      await this.fetchHrmProjects();
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy-hrm {
  &__actions {
    margin-bottom: 20px;
  }

  &__table-actions {
    display: flex;
  }

  &__actions-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
  }
}
</style>
